/*
JTM - Cushion Fabric Yardage Calculator link and modal JS
*/
$(document).ready(function () {

  if($("#calc-render").length > 0){
  
	$('#calcute').click(function (e) {

		e.preventDefault();

		/* if ($('#finished_width').valid() && $('#finished_length').valid() && $('#thickness').valid() && $('#quantity').valid() && $('#fabric_width').valid())
		{ */
		if ($('#finished_width').val() !== "" && $('#finished_length').val() !== "" && $('#thickness').val() !== "" && $('#quantity').val() !== "" && $('#fabric_width').val() !== "") {

			edgeAllowance = 0.5;
			var finishedwidth = parseInt($("#finished_width").val());
			var finishedlength = parseInt($("#finished_length").val());
			var thickness = $("#thickness").val();
			var quantity = $("#quantity").val();
			var include = $("input[type='radio'][name='box_include']:checked").val();
			var foamWidth = parseInt(finishedwidth) + edgeAllowance;
			var foamLength = parseInt(finishedlength) + edgeAllowance;
			var zipperSliderQty = quantity;
			var fabricWidth = parseInt($("#fabric_width").val());
			var orientation = $('input[name="orientation"]:checked').val();

			$("#calc-render .show-after-submit").removeClass("hide-me");

			switch (include) {
				case "Full Cushion":
					var numOfPlates = parseInt(quantity) * 2;
					var plaqueLength = Math.round(parseInt(quantity) * (parseInt(finishedlength) + 2));
					var boxingWidth = parseInt(thickness) + edgeAllowance;
					var boxingLength = Math.round(((parseInt(quantity) * (((parseInt(finishedwidth) * 2) + parseInt(finishedlength)) + (4 * edgeAllowance))) * 1.05));
					var plaquewidth = boxingWidth + 1.25;
					var binding = Math.round((2 * (parseInt(quantity) * ((parseInt(finishedwidth) + parseInt(finishedlength)) * 2)) * 1.05));
					var StraightCutAdditionalFabric = Math.round(binding / parseInt(fabricWidth)) * 1.75;
					var bindingSource = Math.round(Math.sqrt(binding * 1.75) + 2);

					if (orientation == 'Width') {
						var howManyPlatesCanFit = Math.floor(parseInt(fabricWidth) / parseInt(finishedlength));
						if (howManyPlatesCanFit < 1) {
							howManyPlatesCanFit = parseInt(fabricWidth) / parseInt(finishedlength);
						}
						var howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
						var inchesNeeded = howManyPlateSections * parseInt(finishedwidth);
					} else {
						var howManyPlatesCanFit = Math.floor(parseInt(fabricWidth) / parseInt(finishedwidth));
						if (howManyPlatesCanFit < 1) {
							howManyPlatesCanFit = parseInt(fabricWidth) / parseInt(finishedwidth);
						}
						var howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
						var inchesNeeded = howManyPlateSections * parseInt(finishedlength); // Plates
					}
					// console.log(inchesNeeded);
					inchesPlate = inchesNeeded;
					inchesNeeded += Math.ceil(plaqueLength / parseInt(fabricWidth)) * plaquewidth; // +Plaque
					// console.log(inchesNeeded);
					inchesPlaque = inchesNeeded;
					inchesNeeded += Math.ceil(boxingLength / parseInt(fabricWidth)) * boxingWidth; // +Boxing
					// console.log(inchesNeeded);
					inchesBoxing = inchesNeeded;

					break;

				case "One Plate & Boxing":
					var numOfPlates = parseInt(quantity) * 1;
					var plaqueLength = Math.round(parseInt(quantity) * (parseInt(finishedlength) + 1.25))
					var boxingWidth = parseInt(thickness) + edgeAllowance;
					var boxingLength = Math.round(((parseInt(quantity) * (((parseInt(finishedwidth) * 2) + parseInt(finishedlength)) + (4 * edgeAllowance))) * 1.05));
					var plaquewidth = boxingWidth + 1.25;
					var binding = (1 * (parseInt(quantity) * ((parseInt(finishedwidth) + parseInt(finishedlength)) * 2)) * 1.05);
					var StraightCutAdditionalFabric = Math.round(binding / parseInt(fabricWidth)) * 1.75;
					var bindingSource = Math.round(Math.sqrt(binding * 1.75) + 2);

					if (orientation == 'Width') {
						var howManyPlatesCanFit = Math.floor(parseInt(fabricWidth) / parseInt(finishedlength));
						if (howManyPlatesCanFit < 1) {
							howManyPlatesCanFit = parseInt(fabricWidth) / parseInt(finishedlength);
						}
						var howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
						var inchesNeeded = howManyPlateSections * parseInt(finishedwidth);
					} else {
						var howManyPlatesCanFit = Math.floor(parseInt(fabricWidth) / parseInt(finishedwidth));
						if (howManyPlatesCanFit < 1) {
							howManyPlatesCanFit = parseInt(fabricWidth) / parseInt(finishedwidth);
						}
						var howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
						var inchesNeeded = howManyPlateSections * parseInt(finishedlength); // Plates
					}
					inchesPlate = inchesNeeded;
					inchesNeeded += Math.ceil(plaqueLength / parseInt(fabricWidth)) * plaquewidth // +Plaque
					inchesPlaque = inchesNeeded;
					inchesNeeded += Math.ceil(boxingLength / parseInt(fabricWidth)) * boxingWidth // +Boxing
					inchesBoxing = inchesNeeded;

					break;
			}
			if (numOfPlates === 1) {
				var plates = " plate";
			} else {
				var plates = " plates";
			}

			var totalPlate = numOfPlates + plates;
			$("#zipperSliderQty").html(zipperSliderQty);
			$("#plaqueLength").html(plaqueLength);
			$("#zipperlength").html(plaqueLength);
			$("#boxingWidth").html(boxingWidth);
			$("#boxingLength").html(boxingLength);
			$("#plaquewidth").html(plaquewidth);
			$("#foamWidth").html(foamWidth);
			$("#plateWidth").html(foamWidth);
			$("#foamLength").html(foamLength);
			$("#plateLength").html(foamLength);
			$("#binding").html(binding);
			$("#bindingSource").html(bindingSource);
			$("#totalPlate").html(totalPlate);
			$("#StraightCutAdditionalFabric").html(StraightCutAdditionalFabric);
			$("#neededyards").html(roundUpToNearest(inchesNeeded / 36));
			$("#inchesPlate").html(inchesPlate);
			$("#inchesPlaque").html(inchesPlaque);
			$("#inchesBoxing").html(inchesBoxing);


			var pixel = 10;//10
			// lable
			// var renditionCanvas = document.getElementById("renditionLabel");
			// var ctx = renditionCanvas.getContext("2d");
			// ctx.fillStyle = "black";
			// ctx.font = "18pt Arial";
			// ctx.clearRect(0, 0, 310, 50);
			// ctx.fillText("Panel Rendition", 10, 25);

			$('.orange_section').remove();
			$('.blue_section').remove();
			$('.green_section').remove();
			$('.remaining_green_section').remove();
			$(".rendition-container").css({
				'width': fabricWidth * pixel
			});
			// $('#greencontainer').removeClass('flexbox');

			//green
			switch (include) {
				case "Full Cushion":

					if (orientation == "Width") {

						if ((finishedlength < fabricWidth && finishedwidth < fabricWidth) || (finishedlength < fabricWidth && finishedwidth == fabricWidth)) {
							// alert(" < < full width");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + foamLength + " X " + foamWidth + "</div>");
								$(".green_section").css({'width': foamLength * pixel, 'height': foamWidth * pixel});
							}

						} else if ((finishedlength > fabricWidth && finishedwidth < fabricWidth) || (finishedlength > fabricWidth && finishedwidth == fabricWidth)) {

							// alert(" > < full width");
							var greensection = Math.ceil(finishedlength / fabricWidth);
							var totalgreensection = greensection * numOfPlates;
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamWidth + "</div>");
								$(".green_section").css({'width': fabricWidth * pixel,'height': foamWidth * pixel});
							}

							var greenRemainWidth = foamLength - fabricWidth;
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='remaining_green_section'>Cut remainders to " + greenRemainWidth + " X " + foamWidth + "</div>");
								$(".remaining_green_section").css({'width': greenRemainWidth * pixel, 'height': foamWidth * pixel});
							}

						} else if (finishedlength < fabricWidth && finishedwidth > fabricWidth) {

							// alert(" < > full width");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + foamLength + " X " + foamWidth + "</div>");
								$(".green_section").css({'width': foamLength * pixel, 'height': foamWidth * pixel});
							}

						} else if ((finishedlength > fabricWidth && finishedwidth > fabricWidth) || (finishedlength == fabricWidth && finishedwidth < fabricWidth) || (finishedlength == fabricWidth && finishedwidth > fabricWidth)) {
							// alert(" > > full width");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamWidth + "</div>");
								$(".green_section").css({'width': fabricWidth * pixel, 'height': foamWidth * pixel});
							}
							var remainders = foamLength - fabricWidth;
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='remaining_green_section'>Cut remainders to " + remainders + " X " + foamWidth + "</div>");
								$(".remaining_green_section").css({'width': remainders * pixel, 'height': foamWidth * pixel});
							}
						}

					} else {

						//full length
						if ((finishedlength < fabricWidth && finishedwidth < fabricWidth) || (finishedlength == fabricWidth && finishedwidth < fabricWidth)) {
							// alert(" < < full length");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + foamWidth + " X " + foamLength + "</div>");
								$(".green_section").css({'width': foamWidth * pixel, 'height': foamLength * pixel});
							}
						} else if (finishedlength > fabricWidth && finishedwidth < fabricWidth) {
							// alert(" > < full length");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + foamWidth + " X " + foamLength + "</div>");
								$(".green_section").css({'width': foamWidth * pixel, 'height': foamLength * pixel});
							}
						} else if ((finishedlength < fabricWidth && finishedwidth > fabricWidth) || (finishedlength == fabricWidth && finishedwidth > fabricWidth)) {
							// alert(" < > full length");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamLength + "</div>");
								$(".green_section").css({'width': fabricWidth * pixel, 'height': foamLength * pixel});
							}
							var remainderswidth = foamWidth - fabricWidth;
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='remaining_green_section'>Cut remainders to " + remainderswidth + " X " + foamLength + "</div>");
								$(".remaining_green_section").css({'width': remainderswidth * pixel, 'height': foamLength * pixel});
							}
						} else if ((finishedlength > fabricWidth && finishedwidth > fabricWidth) || (finishedlength < fabricWidth && finishedwidth == fabricWidth) || (finishedlength > fabricWidth && finishedwidth == fabricWidth)) {
							// alert(" > > full length");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamLength + "</div>");
								$(".green_section").css({'width': fabricWidth * pixel, 'height': foamLength * pixel});
							}
							var remainders = foamWidth - fabricWidth;
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='remaining_green_section'>Cut remainders to " + remainders + " X " + foamLength + "</div>");
								$(".remaining_green_section").css({'width': remainders * pixel, 'height': foamLength * pixel});
							}

						}
					}

					break;

				case "One Plate & Boxing":

					if (orientation == "Width") {
						if ((finishedlength < fabricWidth && finishedwidth < fabricWidth) || (finishedlength < fabricWidth && finishedwidth == fabricWidth)) {
							// alert(" < < one width");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + foamLength + " X " + foamWidth + "</div>");
								$(".green_section").css({'width': foamLength * pixel, 'height': foamWidth * pixel});
							}
						} else if ((finishedlength > fabricWidth && finishedwidth < fabricWidth) || (finishedlength > fabricWidth && finishedwidth == fabricWidth)) {
							// alert(" > < one width");
							var greensection = Math.ceil(finishedlength / fabricWidth);
							var totalgreensection = greensection * numOfPlates;
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamWidth + "</div>");
								$(".green_section").css({'width': fabricWidth * pixel, 'height': foamWidth * pixel});
							}
							var greenRemainWidth = foamLength - fabricWidth;
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='remaining_green_section'>Cut remainders to " + greenRemainWidth + " X " + foamWidth + "</div>");
								$(".remaining_green_section").css({'width': greenRemainWidth * pixel, 'height': foamWidth * pixel});
							}

						} else if (finishedlength < fabricWidth && finishedwidth > fabricWidth) {
							// alert(" < > one width");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut " + totalPlate + " " + foamLength + " X " + foamWidth + "</div>");
								$(".green_section").css({'width': foamLength * pixel, 'height': foamWidth * pixel});
							}
						} else if ((finishedlength > fabricWidth && finishedwidth > fabricWidth) || (finishedlength == fabricWidth && finishedwidth < fabricWidth) || (finishedlength == fabricWidth && finishedwidth > fabricWidth)) {
							// alert(" > > one width");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamWidth + "</div>");
								$(".green_section").css({'width': fabricWidth * pixel, 'height': foamWidth * pixel});
							}
							var remainders = foamLength - fabricWidth;
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='remaining_green_section'>Cut remainders to " + remainders + " X " + foamWidth + "</div>");
								$(".remaining_green_section").css({'width': remainders * pixel, 'height': foamWidth * pixel
								});
							}
						}

					} else {

						//one length
						if ((finishedlength < fabricWidth && finishedwidth < fabricWidth) || (finishedlength == fabricWidth && finishedwidth < fabricWidth)) {
							// alert(" < < one length");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + foamWidth + " X " + foamLength + "</div>");
								$(".green_section").css({'width': foamWidth * pixel, 'height': foamLength * pixel});
							}
						} else if (finishedlength > fabricWidth && finishedwidth < fabricWidth) {
							// alert(" > < one length");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut " + totalPlate + " " + foamWidth + " X " + foamLength + "</div>");
								$(".green_section").css({'width': foamWidth * pixel, 'height': foamLength * pixel});
							}
						} else if ((finishedlength < fabricWidth && finishedwidth > fabricWidth) || (finishedlength < fabricWidth && finishedwidth == fabricWidth) || (finishedlength == fabricWidth && finishedwidth > fabricWidth)) {
							// alert(" < > one length");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut " + totalPlate + " " + fabricWidth + " X " + foamLength + "</div>");
								$(".green_section").css({'width': fabricWidth * pixel, 'height': foamLength * pixel});
							}
							var remainderswidth = foamWidth - fabricWidth;
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='remaining_green_section'>Cut remainders to " + remainderswidth + " X " + foamLength + "</div>");
								$(".remaining_green_section").css({'width': remainderswidth * pixel, 'height': foamLength * pixel});
							}
						} else if ((finishedlength > fabricWidth && finishedwidth > fabricWidth) || (finishedlength > fabricWidth && finishedwidth == fabricWidth)) {
							// alert(" > > one length");
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='green_section'>Cut 1 plate " + fabricWidth + " X " + foamLength + "</div>");
								$(".green_section").css({'width': fabricWidth * pixel, 'height': foamLength * pixel});
							}
							var remainders = foamWidth - fabricWidth;
							for (var g = 1; g <= numOfPlates; g++) {
								$("#greencontainer").append("<div class='remaining_green_section'>Cut remainders to " + remainders + " X " + foamLength + "</div>");
								$(".remaining_green_section").css({'width': remainders * pixel, 'height': foamLength * pixel});
							}
						}
					}

					break;
			}

			//orange
			var orangesection = Math.ceil(boxingLength / fabricWidth);
			for (var o = 1; o <= orangesection; o++) {
				$("#orangecontainer").append("<div class='orange_section'>Boxing in orange " + boxingWidth + " wide</div>");
				$(".orange_section").css({'width': fabricWidth * pixel, 'height': boxingWidth * pixel});
			}

			//blue
			var bluesection = Math.ceil(plaqueLength / fabricWidth);
			for (var b = 1; b <= bluesection; b++) {
				$("#bluecontainer").append("<div class='blue_section'>Plaque in blue " + plaquewidth + " wide</div>");
				$(".blue_section").css({'width': fabricWidth * pixel, 'height': plaquewidth * pixel});
			}
		}

		// remove hash but causes extra history state
		//history.replaceState(null, null, ' ');
		//var url = window.location.url;
		//window.location.replace(url);

		return false;
	});

	function roundUpToNearest(elemValue,toNearest) {
      
		var newValue = null;
		if (elemValue !== null) {
			var originalValue = elemValue;
			if (elemValue.toString().charAt(0) == "0" && elemValue.length > 1) {
				return originalValue;
			}
			var changeValue = (Math.floor(1000 * elemValue) / 1000).toFixed(2);
			if (toNearest === undefined) {
				toNearest = 0.5;
			}
			var changeValue = Number((Math.ceil(elemValue / toNearest) * toNearest).toFixed(2));
			newValue = "";
			if (changeValue === 0.00) {
				newValue = originalValue;
			} else if (changeValue == 1.00) {
				newValue = originalValue;
			} else {
				newValue = changeValue;
			}
		}
		return newValue;
	}

	$('#calc-render .help').click(function (e) {

		e.preventDefault();
		var $this = $(this);
		var dataHelpID = $this.parents(".calculator-input-wrapper").attr("data-help-id");
		$("#calc-render .info_two").not(dataHelpID).css("display", "none");
		$(dataHelpID).css("display", "block");
		return false;
	});

	$('#calc-render .help-close').click(function (e) {

		e.preventDefault();
		var $this = $(this);
		$this.parents(".info_two").css("display", "none");
		return false;
	});

  } // end if #calc-render
}); // end doc ready